module.exports = __webpack_public_path__ + "img/lucasfernandes_formal.59bdd53a.jpg";